/**
 * 문자 그리드를 Phaser 캔버스 텍스처로 굽는 헬퍼.
 * 프레임이 여러 장이면 가로로 이어 붙인 스프라이트시트로 만든다.
 */

import type Phaser from 'phaser';
import { renderGrid, size, type Grid, type Palette } from '../art/grid';

export function bakeSheet(
  scene: Phaser.Scene,
  key: string,
  grids: readonly Grid[],
  palette: Palette,
  scale: number,
): { frameWidth: number; frameHeight: number } {
  const first = size(grids[0]);
  const fw = first.w * scale;
  const fh = first.h * scale;

  if (scene.textures.exists(key)) scene.textures.remove(key);

  const tex = scene.textures.createCanvas(key, fw * grids.length, fh);
  if (!tex) throw new Error(`캔버스 텍스처 생성 실패: ${key}`);

  const ctx = tex.getContext();
  ctx.imageSmoothingEnabled = false;
  grids.forEach((g, i) => renderGrid(ctx, g, palette, scale, i * fw, 0));
  grids.forEach((_, i) => tex.add(i, 0, i * fw, 0, fw, fh));
  tex.refresh();

  return { frameWidth: fw, frameHeight: fh };
}
